export default __webpack_public_path__ + "static/media/section3-icon1.200c93a4.png";